// Copyright (c) 2025 by Audere

import { useSelector } from "react-redux";
import {
  selectCurrentEmail,
  selectCurrentName,
  selectCurrentPicture,
  selectCurrentUserPersistentGroupRole,
} from "../features/slices/authSlice";
import { LabelingRole } from "../features/api/labelApiSlice";

export function useCurrentUser() {
  const email = useSelector(selectCurrentEmail);
  const name = useSelector(selectCurrentName);
  const picture = useSelector(selectCurrentPicture);
  const role = useSelector(selectCurrentUserPersistentGroupRole).role;
  const group = useSelector(selectCurrentUserPersistentGroupRole).group;

  const isQC = role === LabelingRole.conversation_label_qc;
  const isLabeler = role === LabelingRole.conversation_labeler;
  const isMonitor = role === LabelingRole.conversation_label_monitor;

  return { email, name, picture, group, role, isQC, isLabeler, isMonitor };
}
